import React from 'react';
import 'date-fns';
import {
  Card,
  CardContent,
  Grid,
  Box,
  FormGroup,
  Avatar,
} from '@material-ui/core';

import { useLocation } from 'react-router-dom';
import { PrimaryButton } from './PrimaryButton';

export const ViewFormCustom = ({
  list = [],
  formClass = '',
  formVariant = 'outlined',
  isView = false,
  isEdit = false,
  buttonSection = {
    isRequired: true,
    list: [{ viewText: 'Edit', editText: 'Update', createText: 'Save' }],
  },
} = {}) => {
  const currentLocation = useLocation();

  return (
    <Card className={`${formClass}`} variant={formVariant}>
      <CardContent>
        {/* Form elements grouped based on the data */}
        {list?.map((group) => (
          <>
            {group?.key && (
              <FormGroup className={group?.groupClass}>
                {/*  Company avatar */}
                <div className={group?.avatar?.formControlClass}>
                  {group?.avatar && (
                    <Avatar variant={group?.avatar?.variant} className={group.avatar.className}>
                      {group?.avatar?.logo}
                    </Avatar>
                  )}

                  <Box pb={2}>
                    <h5 className={group?.groupLabelClass}> {group?.groupLabel} </h5>
                  </Box>
                </div>

                <Grid container spacing={1}>
                  {group?.inputs?.map((itemVal, index) => (
                    <Grid
                      item
                      xs={itemVal?.xs || 12}
                      sm={itemVal?.sm || 12}
                      md={itemVal?.md || 6}
                      lg={itemVal?.lg || 4}
                      xl={itemVal?.xl || 4}
                    >
                      {/* Type: Text */}
                      {itemVal?.type !== "linkButton" && itemVal?.action !== "create" &&
                        <Box className={itemVal?.formElementClass} key={index}>
                          <label className={itemVal?.labelClass}> {itemVal?.label} </label>
                          <Box pt={1}>
                            <p className="text-muted">{itemVal?.label} Data </p>
                          </Box>
                        </Box>
                    }
                    </Grid>
                  ))}
                </Grid>
              </FormGroup>
            )}
          </>
        ))}

        {buttonSection.isRequired &&
          buttonSection?.list?.map((button, buttonIndex) => (
            <Grid container spacing={1} key={buttonIndex}>
              <Grid item xs={12}>
                <Box mt={2}>
                  <PrimaryButton
                    text={isView ? button.viewText : isEdit ? button.editText : button.createText}
                  />
                </Box>
              </Grid>
            </Grid>
          ))}
      </CardContent>
    </Card>
  );
};